import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import messages from '../../../../res/translations/messages';
import TooltipContainer from '../../TooltipContainer';

const InvertBatteryButton = ({onClick}) => (
    <TooltipContainer component="button" tooltip={messages.surveys.tooltips.invertBattery}
        className="btn btn-link" type="button" onClick={onClick}>
        <FontAwesomeIcon icon="exchange-alt" />
    </TooltipContainer>
);

export default InvertBatteryButton;
